	import React, { useContext, useState, useEffect } from "react";
	import { TranslatorContext } from "../../../context/Translator";
	import PageLayout from "../../../layouts/PageLayout";
	import { Link } from "react-router-dom";
	import { Row, Col, Button } from "react-bootstrap";
	import Modal from "react-bootstrap/Modal";
	import axios from "axios";
	import AddUser from "./CreateUser";
	import UpdateUser from "./EditUser";
	import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
	import { faEye } from "@fortawesome/free-solid-svg-icons";
	import "bootstrap/dist/js/bootstrap.bundle.min.js";
	import { useNavigate } from "react-router-dom";



	export default function ListUsers() {

		const navigate = useNavigate();

		const { t } = useContext(TranslatorContext);
		const AuthToken = localStorage.getItem("AuthUser");

		const [data, setData] = useState([]);
		const [searchQuery, setSearchQuery] = useState("");
		const [showForm, setShowForm] = useState(false);
		const [isEditMode, setIsEditMode] = useState(false);
		const [editUser, setEditUser] = useState(null);

		useEffect(() => {
		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		[...tooltipTriggerList].forEach(
		(tooltipTriggerEl) => new window.bootstrap.Tooltip(tooltipTriggerEl)
		);
	}, []);


		useEffect(() => {
			const fetchData = async () => {
				try {
					axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
					const response = await axios.get(process.env.REACT_APP_API_URL + "/all-users");
					setData(response.data);
					console.log("all data",response.data);
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			};
			fetchData();
		}, []);
					const users = data.users;

		// Handle search
		const handleSearch = (event) => {
			setSearchQuery(event.target.value.toLowerCase());
		};

		// Filter data
		const filteredData = data.users?.filter((item) =>
			Object.values(item).some((val) =>
				String(val).toLowerCase().includes(searchQuery)
			)
		);
		
	useEffect(() => {
	console.log("user roles in userlist", data?.users?.map((u)=>{
		return u.permissions}));
	}, [data]);

	return (
			<PageLayout>
				<Row>
					<Col xl={12}>
						<div className="mc-card">
							<div className="mc-breadcrumb">
								<h3 className="mc-breadcrumb-title">List Users</h3>
								<ul className="mc-breadcrumb-list">
									<li className="mc-breadcrumb-item"><Link to="#"style={{color:"#077834"}}>Home</Link></li>
									<li className="mc-breadcrumb-item"><Link to="#"style={{color:"#077834"}}>Users</Link></li>
									<li className="mc-breadcrumb-item">List Users</li>
								</ul>
							</div>
						</div>
					</Col>

					<Col xl={12}>
						<div className="mc-card">
							<Row>
								<Col xl={6}>
									<div className="add-button">
										<Button
											className=""
											style={{backgroundColor:"#077834",color:"white",border:"none"}}
											onClick={() => {
												setIsEditMode(false);
												setEditUser(null);
												setShowForm(true);
											}}
										>
											+
										</Button>
									</div>
								</Col>
								<Col xl={6}>
									<div className="mc-search">
										<input
											type="text"
											placeholder={t("search")}
											value={searchQuery}
											onChange={handleSearch}
											className="form-control table-search"
										/>
									</div>
								</Col>
							</Row>

							{/* Table */}
							<Row>
								<Col xl={12}>
									<table className="table">
										<thead>
											<tr>
												<th>#
												
												</th>
												<th>Name</th>
												<th>Phone</th>
												<th>Organization</th>
												<th>Permissions</th>
												<th>Actions</th>
											</tr>
										</thead>
										<tbody>
											{filteredData?.map((user, index) => (
												<tr key={user.id || index}>
													<td>{index + 1} <span> </span><a className="mc-round-avatar xs" href="#">
														<img src={process.env.REACT_APP_IMG_URL + user.avatar} alt="avatar"/></a>
													</td>
													<td>{user.name}</td>
													<td>{user.phone}</td>
													<td>{user?.organization?.name}</td>
													<td>
														<p className="text-center mb-0">{user.role?.name}</p>
														<hr />
														{user?.permissions?.map((per, i) => (
															<p key={i} className="mb-0 text-center">{per.name}</p>
														))}
													</td>
													<td>
	<div className=" d-flex justify-content-center">
		<Button
															className=""
															style={{backgroundColor:"#077834",color:"#fff",border:"1px solid #077834"}}
															onClick={() => {
																setIsEditMode(true);
																setEditUser(user);
																setShowForm(true);
															}}
														>
															Edit
														</Button></div>

														<div className=" d-flex justify-content-center">
															<FontAwesomeIcon
		style={{ cursor: "pointer", backgroundColor:"rgba(7, 120, 52, 0.7)",color:"black",borderRadius:"5px"}}
	
		className="m-2 p-1"
		icon={faEye}
		size="lg"
	onClick={() =>
	navigate(`/user-details/${user.id}`, { state: { user} })
	}

		/>
		</div>
																

													</td>

													
												</tr>
											))}
										</tbody>
									</table>
								</Col>
							</Row>

							{/* Modal  */}
							<Modal
	className="custom-dialog"   
	show={showForm}
	onHide={() => setShowForm(false)}
	size="lg"
	>
	<Modal.Header closeButton>
		<Modal.Title></Modal.Title>
	</Modal.Header>
	<Modal.Body>
		{isEditMode ? (
		<UpdateUser user={editUser} setShowForm={setShowForm} setData={setData} data={data} />
		) : (
		<AddUser setShowForm={setShowForm} setData={setData} data={data} />
		)}
	</Modal.Body>
	</Modal>

						</div>
					</Col>
				</Row>
			</PageLayout>
		);
	}
